import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rc2001',
    ecrans: ['00-2'],
    params: ['id', 'prpcleint', '?vaesysmodcod', '?daccleint']
});
